import { useState, useRef, useCallback } from 'react'

export type CleanupFunction = () => void

export const useVisiblePage = () => {
    const [visiblePage, setVisiblePage] = useState<number | null>(null)
    const observerRef = useRef<IntersectionObserver | null>(null)

    const callback = useCallback((entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const pageIndex = parseInt(entry.target.getAttribute('data-page-index') || '0')
                setVisiblePage(pageIndex + 1)
            }
        })
    }, [])

    const cleanup = useCallback(() => {
        if (observerRef.current) {
            observerRef.current.disconnect()
            observerRef.current = null
        }
    }, [])

    const observe = useCallback(
        (elements: Element[]) => {
            cleanup()

            observerRef.current = new IntersectionObserver(callback, {
                threshold: 0.3,
            })

            elements.forEach((element) => {
                observerRef.current?.observe(element)
            })
        },
        [callback, cleanup]
    )

    return { visiblePage, observe, cleanup }
}
